import { putUser } from '../../services/api/user.api';
import { UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[UPDATE_USER_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[UPDATE_USER_SUCCESS](state) {
			state.isLoading = false;
		},
		[UPDATE_USER_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateUser({ commit }, { id, params }) {
			try {
				commit(UPDATE_USER_REQUEST);
				await putUser(id, params);
				commit(UPDATE_USER_SUCCESS);
			} catch (error) {
				commit(UPDATE_USER_FAILURE, error);
			}
		},
	},
};